<template>
  <div v-if="fonts.length" class="font-preload">
    <font-preload
      v-for="(font, index) in fontNames"
      :key="'font-preload' + index"
      :font-name="font"
    />
  </div>
</template>

<script>
import FontPreload from './FontPreload';

export default {
  name: 'FontsGroup',
  components: { FontPreload },
  data() {
    return {
      fontNames: ['Dosis-Bold', 'Dosis-Regular', 'Nunito-Regular', 'icomoon'],
    };
  },
  props: {
    fonts: {
      type: Array,
      required: true,
    },
  },
  watch: {
    fonts: {
      immediate: true,
      handler: function (value) {
        if (value) {
          this.fontNames = this.fontNames.concat(value);
        }
      },
    },
  },
};
</script>

<style lang="stylus" scoped>
.font-preload
  opacity 0
</style>
